import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from 'axios';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../Config';
import Beatloader from '../../../Common/Loaders/Beatloader';


const EditRateclass = ({ rateclass_id, show, handleClose, token, user_id, refresh, loadingMasterRateclassDetail, MasterRateclassDetail }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);

    let [showLoader, setShowLoader] = useState(false);

    let initialValues = {
        name: "",
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if (rateclass_id) {
                    values.id = rateclass_id
                } else {
                    toast.error("Country id not found. Please retry or contact admin.");
                    return;
                }
                // console.log(values);
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/rateclass/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingMasterRateclassDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (MasterRateclassDetail) {
            // console.log(MasterRateclassDetail);
            formik.setFieldValue("name", MasterRateclassDetail?.name);
        }
    }, [loadingMasterRateclassDetail, MasterRateclassDetail]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement={"end"} name={"end"}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Rate/Class Details</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className={`col-md-12 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Rate/Class
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                    type="text"
                                                    maxLength={5}
                                                    className="form-control form-control-sm"
                                                    id={"name"}
                                                    name={"name"}
                                                    value={formik.values.name}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row d-flex justify-content-end mt-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                        </>
                                                        :
                                                        "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </form>
                        </Offcanvas.Body>
                    </Offcanvas>
            }

        </>
    )
}

export default EditRateclass